import { render, staticRenderFns } from "./GoSchool.vue?vue&type=template&id=8a33efb8&scoped=true&"
import script from "./GoSchool.vue?vue&type=script&lang=js&"
export * from "./GoSchool.vue?vue&type=script&lang=js&"
import style0 from "./GoSchool.vue?vue&type=style&index=0&id=8a33efb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a33efb8",
  null
  
)

export default component.exports